module.exports = __webpack_public_path__ + "static/media/google.21487b43.png";